import constant from '../../constant';
import { getShareParams } from '../../../utils/yUtil'

const getCommon = (route) => {
  const commonParams = getShareParams(route)
  return {
    type: constant.COMMON.GET_PARAMS,
    common: {
      ...commonParams
    }
  }
}

const setPageState = (payload) => {
  return {
    type: constant.COMMON.PAGE_STATE,
    payload
  }
}

export default {
  getCommon,
  setPageState
}
